import { useState } from "react";
import useDebounce from "./useDebounce";

const useSelectSearch = ({ delay = 400 }: { delay?: number } = {}) => {
  const [searchValue, setSearchValue] = useState("");
  const onSearch = useDebounce(
    (value: string) => setSearchValue(value.trim()),
    delay,
  );
  return { searchValue, onSearch };
};

export default useSelectSearch;
